(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yadegari-product-jeweller"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-yad-jeweller]').forEach((section) => {
      if (section.dataset.yadReady === 'true') return;
      section.dataset.yadReady = 'true';
      section.querySelectorAll('[data-yad-event]').forEach((element) => {
        element.addEventListener('click', () => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: `yadegari_${element.dataset.yadEvent}`, product_id: section.dataset.productId });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yadegari-product-page"]) return;
  try {
    
  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-yad-engraving-input]');
    if (!input) return;
    const preview = input.closest('[data-yad-personalization]')?.querySelector('[data-yad-engraving-preview]');
    if (!preview) return;
    preview.textContent = input.value || input.placeholder;
  });

  document.addEventListener('click', (event) => {
    const element = event.target.closest('[data-yad-pdp-jeweller] [data-yad-event]');
    if (!element) return;
    const panel = element.closest('[data-yad-pdp-jeweller]');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `yadegari_${element.dataset.yadEvent}`, product_id: panel.dataset.productId });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yadegari-product-viewing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-yad-viewing]').forEach((section) => {
      if (section.dataset.yadReady === 'true') return;
      section.dataset.yadReady = 'true';
      const variants = JSON.parse(section.querySelector('[data-yad-viewing-variants]')?.textContent || '[]');
      const pushEvent = (name) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: `yadegari_${name}`, product_id: section.dataset.productId });
      };
      const updateLeadContext = () => {
        const productInfo = document.querySelector(`product-info[data-product-id="${section.dataset.productId}"]`);
        const id = productInfo?.querySelector('.product-variant-id')?.value;
        const variant = variants.find((item) => String(item.id) === String(id));
        const variantInput = section.querySelector('[data-yad-lead-variant]');
        const skuInput = section.querySelector('[data-yad-lead-sku]');
        if (variantInput) variantInput.value = variant?.title || '';
        if (skuInput) skuInput.value = variant?.sku || '';
        const productUrl = new URL(productInfo?.dataset.url || window.location.pathname, window.location.origin);
        if (variant?.id) productUrl.searchParams.set('variant', variant.id);
        const panels = document.querySelectorAll(
          `[data-yad-pdp-jeweller][data-product-id="${section.dataset.productId}"], [data-yad-jeweller][data-product-id="${section.dataset.productId}"]`
        );
        panels.forEach((panel) => panel.querySelectorAll('a[data-yad-event="ask_jeweller"]').forEach((link) => {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('variant', variant?.title || '');
          url.searchParams.set('sku', variant?.sku || '');
          url.searchParams.set('product_url', productUrl.href);
          link.href = url.href;
        }));
      };
      document.addEventListener('change', (event) => {
        if (!event.target.matches('product-info .product-variant-id')) return;
        updateLeadContext();
      });
      section.querySelector('form')?.addEventListener('submit', updateLeadContext);
      updateLeadContext();
      section.querySelectorAll('[data-yad-event]').forEach((element) => element.addEventListener('click', () => pushEvent(element.dataset.yadEvent)));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
